(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__gryffitAddToCartTotalPriceInitialized) return;
    window.__gryffitAddToCartTotalPriceInitialized = true;

    class AddToCartTotalPrice {
      constructor() {
        this.onQuantitySelectorUpdate = this.onQuantitySelectorUpdate.bind(this);
        this.onVariantUpdate = this.onVariantUpdate.bind(this);
        this.onQuantityInput = this.onQuantityInput.bind(this);

        document.addEventListener('quantity-selector:update', this.onQuantitySelectorUpdate);
        document.addEventListener('variant:update', this.onVariantUpdate);
        document.addEventListener('input', this.onQuantityInput, true);

        this.updateAll();
      }

      onQuantityInput(event) {
        if (!(event.target instanceof HTMLInputElement)) return;
        if (event.target.type !== 'number') return;
        if (!event.target.closest('quantity-selector-component')) return;
        this.updateForTarget(event.target);
      }

      onQuantitySelectorUpdate(event) {
        this.updateForTarget(event.target, event.detail?.quantity);
      }

      onVariantUpdate(event) {
        const variant = event.detail?.resource;
        const price = typeof variant?.price === 'number' ? variant.price : parseInt(variant?.price, 10);
        if (!Number.isFinite(price)) return;

        const form = event.target instanceof Element ? event.target.closest('form') : null;
        if (!form) return this.updateAll();

        form.querySelectorAll('.total-price-display').forEach((display) => {
          if (!(display instanceof HTMLElement)) return;
          display.dataset.basePrice = String(price);
        });

        this.updateForForm(form);
      }

      updateForTarget(target, quantityOverride) {
        const form = target instanceof Element ? target.closest('form') : null;
        if (!form) return this.updateAll();
        this.updateForForm(form, quantityOverride);
      }

      updateAll() {
        document.querySelectorAll('form').forEach((form) => {
          if (!(form instanceof HTMLFormElement)) return;
          if (!form.querySelector('.total-price-display')) return;
          this.updateForForm(form);
        });
      }

      updateForForm(form, quantityOverride) {
        const quantityInput = form.querySelector('quantity-selector-component input[type="number"]');
        const quantityFromInput = parseInt(quantityInput?.value || '1', 10) || 1;
        const quantity = typeof quantityOverride === 'number' ? quantityOverride : quantityFromInput;

        form.querySelectorAll('.total-price-display').forEach((display) => {
          if (!(display instanceof HTMLElement)) return;
          const basePrice = parseInt(display.dataset.basePrice || '0', 10);
          if (!Number.isFinite(basePrice)) return;

          const totalPrice = basePrice * quantity;
          display.textContent = this.formatMoney(totalPrice, display);
        });
      }

      formatMoney(cents, displayEl) {
        const container = displayEl.closest('add-to-cart-component');
        const template = container?.dataset.moneyFormat || '{{amount}}';
        const currency = container?.dataset.currency || '';

        const defaultPrecision = currency
          ? new Intl.NumberFormat(undefined, { style: 'currency', currency }).resolvedOptions().maximumFractionDigits
          : 2;

        return template.replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
          if (placeholder === 'currency') return currency;

          let thousandsSeparator = ',';
          let decimalSeparator = '.';
          let precision = defaultPrecision;

          if (placeholder === 'amount') {
          } else if (placeholder === 'amount_no_decimals') {
            precision = 0;
          } else if (placeholder === 'amount_with_comma_separator') {
            thousandsSeparator = '.';
            decimalSeparator = ',';
          } else if (placeholder === 'amount_no_decimals_with_comma_separator') {
            thousandsSeparator = '.';
            precision = 0;
          } else if (placeholder === 'amount_no_decimals_with_space_separator') {
            thousandsSeparator = ' ';
            precision = 0;
          } else if (placeholder === 'amount_with_space_separator') {
            thousandsSeparator = ' ';
            decimalSeparator = ',';
          } else if (placeholder === 'amount_with_period_and_space_separator') {
            thousandsSeparator = ' ';
            decimalSeparator = '.';
          } else if (placeholder === 'amount_with_apostrophe_separator') {
            thousandsSeparator = "'";
            decimalSeparator = '.';
          }

          return this.formatCents(cents, thousandsSeparator, decimalSeparator, precision);
        });
      }

      formatCents(cents, thousandsSeparator, decimalSeparator, precision) {
        const roundedNumber = (cents / 100).toFixed(precision);
        let [a, b] = roundedNumber.split('.');
        if (!a) a = '0';
        if (!b) b = '';

        a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, (digit) => digit + thousandsSeparator);
        return precision <= 0 ? a : a + decimalSeparator + b.padEnd(precision, '0');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => new AddToCartTotalPrice(), { once: true });
    } else {
      new AddToCartTotalPrice();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
